<template>
  <div class="header">
    <a-form class="form" layout="vertical" :model="formState">
      <EntityPicker
        v-model:value="formState.entity"
        default-behavior
        :show-all="false"
        label="Empresa"
        required
      />
    </a-form>

    <a-button type="primary" :disabled="isDisabled" @click="handleDownload">
      Descargar <DownloadOutlined />
    </a-button>
  </div>

  <section class="info">
    Este reporte solo se podrá descargar al
    <br />
    aplicar los filtros
  </section>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from "vue";
import { DownloadOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";

import { DownloadDto, phonesReportService } from "@/app/reports/services/PhonesReport.service";
import { ResponseError } from "@/app/shared/utils/httpManager";

import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";

const formState: Partial<DownloadDto> = reactive({
  entity: undefined,
});

const isDisabled = computed(() => {
  let disabled = false;

  for (const key in formState) {
    if (!formState[key as keyof typeof formState]) {
      disabled = true;
      break;
    }
  }

  return disabled;
});

const loading = ref(false);

const handleDownload = async () => {
  loading.value = true;

  try {
    await phonesReportService.download(formState as DownloadDto);
    message.success("Se ha encolado la descarga");
  } catch (error) {
    let errorMessage = "Ha ocurrido un error";
    if (error instanceof ResponseError) errorMessage = error.getErrorMessage();
    message.error(errorMessage);
    console.error(error);
  }

  loading.value = false;
};
</script>

<style scoped lang="sass">
.header
  display: flex
  justify-content: space-between
  align-items: flex-end
  margin-top: 12px

.form
  display: flex
  gap: 8px

  > .ant-form-item
      width: 240px
      margin: 0

.info
  display: grid
  place-content: center
  text-align: center
  color: $gray-7
  font-size: 20px
  font-weight: 400
  margin-top: 150px
</style>
